module.exports = __webpack_public_path__ + "img/treeplant2_7-8-2021.21fc5ba6.jpg";